import * as React from 'react'
import { LYSContainer } from '@core/components/Primitives'
import PageLayout from '../../prismic/components/PageLayout'
import { IPageLayout } from '../../prismic/types'
import Head from 'next/head'
import config from '@core/config/config'

interface Props {
  pageLayout: IPageLayout
}

const CustomPrismicPage: React.FC<Props> = ({ pageLayout }) => {
  return (
    <LYSContainer padded={true}>
      <Head>
        <script
          async
          defer
          src={`https://static.cdn.prismic.io/prismic.js?new=true&repo=${config.prismic.name}`}
        />
      </Head>
      <PageLayout layout={pageLayout} />
    </LYSContainer>
  )
}

export default CustomPrismicPage
